import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import {Dialog} from "primereact/dialog";
import axios from 'axios';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import {InputNumber} from "primereact/inputnumber";
import {TabView, TabPanel} from 'primereact/tabview';

import PartnerListComponent from "../../components/2.1/partner/PartnerListComponent";
import PartnerFormComponent from "../../components/2.0/partner/PartnerFormComponent";
import SchedulegroupListComponent from "../../components/2.1/production/schedulegroup/SchedulegroupListComponent";
import SchedulegroupFormComponent from "../../components/2.1/production/schedulegroup/SchedulegroupFormComponent";
import ScheduleFormComponent from "../../components/2.1/production/schedule/ScheduleFormComponent";
import ScheduleitemCalendarComponent from "../../components/2.1/production/scheduleitem/ScheduleitemCalendarComponent";
import WorksheetFormComponent from "../../components/2.0/worksheet/WorksheetFormComponent";
import MetricsListComponent from "../../components/2.0/metrics/MetricsListComponent";
import MetricsFormComponent from "../../components/2.0/metrics/MetricsFormComponent";
import ProductionOverview from "../../components/2.1/production/productionoverview/ProductionOverview"; 
import ProductionitemCalendarListComponent from '../../components/2.1/production/scheduleitem/ProductionitemCalendarListComponent';
import MachinelogListComponent from '../../components/2.1/production/machinelog/MachinelogListComponent';
import ProductionitemListComponent from '../../components/2.1/production/productionitem/ProductionitemListComponent';
import ProductionjobListComponent from '../../components/2.1/production/productionjob/ProductionjobListComponent';
import ProductionstatusFloorplanComponent from '../../components/2.1/production/productionstatusfloorplan/ProductionstatusFloorplanComponent';
import FloorplanComponent from '../../components/2.1/production/floorplan/FloorplanComponent';
import MachineListComponent from '../../components/2.1/production/machine/MachineListComponent';
import MachineFormComponent from '../../components/2.1/production/machine/MachineFormComponent';
import EmployeeListComponent from '../../components/2.1/hr/empoloyee/EmployeeListComponent';
import CooperationListComponent from '../../components/2.1/production/cooperation/CooperationListComponent';
import CooperationFormComponent from '../../components/2.1/production/cooperation/CooperationFormComponent';
import ProjectitemFormComponent from '../../components/2.1/production/projectitem/ProjectitemFormComponent';
import ProjectitemListComponent from '../../components/2.1/production/projectitem/ProjectitemListComponent';
import ProductionItemsComponent from "../../components/2.1/production/productionitems/ProductionItemsComponent";
import ScheduleitemListComponent from "../../components/2.1/production/scheduleitem/ScheduleitemListComponent";
import TracklogListComponent from "../../components/2.1/production/tracklog/TracklogListComponent";
import ProjectProjectitemListComponent from "../../components/2.1/project/projectitem/ProjectitemListComponent";
import ProjectitemShowComponent from "../../components/2.1/production/projectitem/ProjectitemShowComponent";
import InventoryListComponent from '../../components/2.1/inventory/inventory/InventoryListComponent';

export const ProjectPage = (props) => {

  const history = useHistory();
  const {t} = props;
  const {entity, action, id} = useParams();
  const [scheduleGroups, setScheduleGroups] = useState([]);
  const [selectedScheduleGroupId, setSelectedScheduleGroupId] = useState(null);
  const [floorPlans, setFloorPlans] = useState([]);
  const [selectedFloorPlanId, setSelectedFloorPlanId] = useState(null);
  const [job, setJob] = useState({});
  const [showProjectDeadlines, setShowProjectDeadlines] = useState(false);
  const [detailedSearchVisible, setDetailedSearchVisible] = useState(false);
  const [detailedSearchActive, setDetailedSearchActive] = useState(false);
  const [projectStatusColor, setProjectStatusColor] = useState('#883cae');
  const [loadingWorksheetDownload, setLoadingWorksheetDownload] = useState(false);
  const [stockDialogVisible, setStockDialogVisible] = useState(false);
  const [projectItemTitle, setProjectItemTitle] = useState('');
  const [stockQuantity, setStockQuantity] = useState(null);
  const [stockLoading, setStockLoading] = useState(false);

  const getProjectItemBacklink = () => {
    const rawBacklink = window.App?.urlVars?.()?.backlink;
    if (!rawBacklink) {
      return '/production/project-item';
    }

    try {
      return decodeURIComponent(rawBacklink);
    } catch (error) {
      return rawBacklink;
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const createStock = () => {
    if (!id || id === 'undefined') return;
    if (!stockQuantity || Number(stockQuantity) <= 0) {
      window.App.toastShow('error', t('error'), 'A mennyiség megadása kötelező.');
      return;
    }
    setStockLoading(true);
    apiCall('post', '/api/v2/project-item/stock/' + id, {
      quantity: stockQuantity
    })
      .then(() => {
        window.App.toastShow('success', t('success'), t('saveSuccess'));
        setStockDialogVisible(false);
        setStockQuantity(null);

        window.App.setState({
          rerenderInventoryList: Math.random()
        });
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setStockLoading(false);
      });
  };

  const downloadWorksheet = () => {
    if (!id || id === 'undefined') return;
    setLoadingWorksheetDownload(true);
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + '/api/v2/project-item/' + id + '/download/pdf',
      responseType: 'blob',
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        const blob = new Blob([response.data], {
          type: response.headers['content-type'] || 'application/pdf'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'munkalap-' + id + '.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba', error.toString(), '', error.response);
      })
      .finally(() => {
        setLoadingWorksheetDownload(false);
      });
  };

  useEffect(() => {
    if (entity !== 'schedule-item' || window.App.urlVars().scheduleId) return;
    apiCall('get', '/api/v2/schedule-group')
      .then((response) => {
        const items = response?.data?.data?.items || [];
        setScheduleGroups(items);
        const urlGroupId = window.App.urlVars().scheduleGroupId
          ? Number(window.App.urlVars().scheduleGroupId)
          : null;
        if (urlGroupId) {
          setSelectedScheduleGroupId(urlGroupId);
        } else {
          setSelectedScheduleGroupId(null);
        }
      })
      .catch(() => {
        setScheduleGroups([]);
        setSelectedScheduleGroupId(null);
      });
  }, [entity]);

  useEffect(() => {
    if (entity !== 'project-item' || action !== 'read' || !id || id === 'undefined') {
      setProjectItemTitle('');
      return;
    }
    apiCall('get', '/api/v2/project-item/' + id)
      .then(response => {
        const title = response?.data?.data?.name || '';

        setProjectItemTitle(title);

        if (title) {
          document.title = title + ' - ' + process.env.REACT_APP_TITLE;
        }
      })
      .catch(() => {
        setProjectItemTitle('');
      });
  }, [entity, action, id]);

  // useEffect(() => {
  //   if (entity !== 'production-status') return;
  //   apiCall('get', '/api/v2/floor-plan?item_per_page=1000')
  //     .then((response) => {
  //       const items = response?.data?.data?.items || response?.data?.data || [];
  //       setFloorPlans(items);
  //       const urlFloorPlanId = window.App.urlVars().floorPlanId ? Number(window.App.urlVars().floorPlanId) : null;
  //       if (urlFloorPlanId) {
  //         setSelectedFloorPlanId(urlFloorPlanId);
  //       } else {
  //         const firstId = items[0]?.id || null;
  //         setSelectedFloorPlanId(firstId);

  //         if (firstId) {
  //           history.replace('/production/production-status?floorPlanId=' + firstId);
  //         }
  //       }
  //     })
  //     .catch(() => {
  //       setFloorPlans([]);
  //       setSelectedFloorPlanId(null);
  //     });
  // }, [entity]);

  useEffect(() => {
    document.title = 'Gyártás' + ' - ' + process.env.REACT_APP_TITLE;
    setTimeout(function () {
      if (document.getElementsByClassName('activeMenu')[0]) {
        document.getElementsByClassName('activeMenu')[0].classList.remove("activeMenu")
      }
      if (document.getElementsByClassName('production')[0]) {
        document.getElementsByClassName('production')[0].classList.add("activeMenu")
      }
    }, 1000)
  }, [window.App.state.rerenderProjectPage]);

  useEffect(() => {
    if (entity !== 'production-status' && entity !== 'floor-plan') return;
    apiCall('get', '/api/v2/floor-plan?item_per_page=1000')
      .then((response) => {
        const items = response?.data?.data?.items || [];
        setFloorPlans(items);
        const urlFloorPlanId = window.App.urlVars().floorPlanId ? Number(window.App.urlVars().floorPlanId) : null;
        setSelectedFloorPlanId(urlFloorPlanId);
      })
      .catch(() => {
        setFloorPlans([]);
        setSelectedFloorPlanId(null);
      });
  }, [entity]);

  return (
    <div className={"ProjectPage"}>
      {localStorage.getItem('module_manufacturing') ? (
          <>
            {/*tmp without routing*/}
            {entity === 'metrics' && localStorage.getItem('roles').toString().includes('role_metrics_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <Panel>
                  <MetricsListComponent view="simple"/>
                </Panel>
              </div>
            }
            <Sidebar position="left" visible={window.App.state.sidebarMetricsCreate} closeOnEscape={true}
                     style={{width: '980px'}}
                     onHide={() => {
                       window.App.setState({
                         sidebarMetricsCreate: false,
                       })
                     }}>
              <h2 className={"text-primary"}>{t('addMetric')}</h2>
              <MetricsFormComponent />
            </Sidebar>
            <Sidebar position="left" visible={window.App.state.sidebarMetricsUpdate} closeOnEscape={true}
                     style={{width: '980px'}}
                     onHide={() => {
                       window.App.setState({
                         sidebarMetricsUpdate: false,
                       })
                     }}>
              <h2 className={"text-primary"}>{t('metricUpdate')}</h2>
              <MetricsFormComponent />
            </Sidebar>
            {!entity &&
              <div className={"PageContent p-p-5 p-mx-auto"}>

              </div>
            }


            {entity === 'productionoverview' && !action && (localStorage.getItem('roles') || '[]').includes('role_production_overview_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <Panel>
                  <ProductionOverview />
                </Panel>
              </div>
            }

            {entity === 'production-items' && (
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <Panel>
                  <ProductionItemsComponent />
                </Panel>
              </div>
            )}

            
            {entity === 'schedule-group' && (!action || action === 'read') && localStorage.getItem('roles').toString().includes('role_schedule_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('scheduleList')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {localStorage.getItem('roles').toString().includes('role_schedule_write') && (
                    <a onClick={() => {
                      history.push('/production/schedule-group/create')
                    }}
                      className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addScheduleGroup')}
                    </a>
                  )}
                  </div>
                </div>
                <Panel>
                  <SchedulegroupListComponent backlink={'/production/schedule-group'}/>
                </Panel>
              </div>
            }
            {entity === 'schedule-group' && (action === 'create' || action === 'update') &&
              <Sidebar position="left"
                       showCloseIcon={false}
                       visible={action === 'create' || action === 'update'}
                       closeOnEscape={true}
                       style={{width: '780px'}}
                       onHide={() => {
                         history.push('/production/schedule-group')
                       }}>
                <div className={"PageContent p-p-5 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('scheduleUpdate') : t('scheduleCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                      <a onClick={() => {
                        history.push('/production/schedule-group')
                      }}
                         className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    <SchedulegroupFormComponent backlink={'/production/schedule-group'}/>
                  </Panel>
                </div>
              </Sidebar>
            }
            {entity === 'schedule-group' && action === 'read' &&
              <Sidebar position="left"
                      showCloseIcon={false}
                      visible={action === 'read'}
                      closeOnEscape={true}  
                      style={{width: '98%'}}
                      onHide={() => {
                        history.push('/production/schedule-group')
                      }}>
                <div className={"PageContent p-p-5 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {t('scheduleParticipants')}
                      </h2>
                    </div>

                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                      <a onClick={() => {
                        history.push('/production/schedule-group')
                      }}
                        className={"p-button p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>

                  <Panel>
                    <ScheduleitemListComponent scheduleId={id} scheduleGroupType={window.App.urlVars().scheduleGroupType} backlink={'/production/schedule-group'}/>
                  </Panel>
                </div>
              </Sidebar>
            }
            {entity === 'schedule-item' && (localStorage.getItem('roles') || '[]').includes('role_schedule_item_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('scheduleAssignment')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                  {!window.App.urlVars().scheduleId &&
                    <div style={{
                        display: 'inline-flex',
                        gap: '0.5rem',
                        alignItems: 'center',
                        minWidth: '420px',
                        textAlign: 'left'
                      }}
                    >
                      <Dropdown
                        value={
                          window.App.urlVars().scheduleGroupId
                            ? Number(window.App.urlVars().scheduleGroupId)
                            : (selectedScheduleGroupId || 'all')
                        }
                        options={[
                          {id: 'all', name: t('all')},
                          ...scheduleGroups
                        ]}
                        optionLabel="name"
                        optionValue="id"
                        placeholder={t('selectScheduleGroup')}
                        onChange={(e) => {
                          const value = e.value;
                          if (value === 'all') {
                            setSelectedScheduleGroupId(null);
                            history.replace('/production/schedule-item');
                            return;
                          }
                          setSelectedScheduleGroupId(value);
                          history.replace('/production/schedule-item?scheduleGroupId=' + value);
                        }}
                        style={{width: '280px'}}
                      />

                      <Button
                        type="button"
                        label={t('showDeadline')}
                        icon={showProjectDeadlines ? 'pi pi-eye' : 'pi pi-eye-slash'}
                        className={showProjectDeadlines ? 'p-button-info' : 'p-button-outlined'}
                        onClick={() => setShowProjectDeadlines(prev => !prev)}
                      />
                    </div>
                  }
                  </div>
                  
                  <div className={"p-col-12 p-lg-8"}>
                    <Panel>
                      <ScheduleitemCalendarComponent scheduleId={window.App.urlVars().scheduleId} selectedScheduleGroupId={selectedScheduleGroupId} showProjectDeadlines={showProjectDeadlines}/>
                    </Panel>
                  </div>

                  <div className={"p-col-12 p-lg-4"} style={{position: 'sticky', top: '20px', alignSelf: 'flex-start', zIndex: 2 }}>
                    <Panel>
                      <ProductionitemCalendarListComponent />
                    </Panel>
                  </div>
                </div>
              </div>
            }
            {entity === 'schedule' && action === 'read' &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12"}>
                    <Panel>
                      <ScheduleitemCalendarComponent scheduleId={id} />
                    </Panel>
                  </div>
                </div>
              </div>
            }
            {entity === 'cooperation' && (!action || action === 'update' || action === 'create') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('cooperation')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                    {/* <a onClick={() => {
                      history.push('/tmp/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addCooperation')}
                    </a> */}
                  </div>
                </div>
                <Panel>
                  <CooperationListComponent backlink={'/production/cooperation'}/>
                </Panel>
              </div>
            }
            {entity === 'cooperation' && (action === 'create' || action === 'update') &&
              <Sidebar position="left"
                        showCloseIcon={false}
                        visible={action === 'create' || action === 'update'}
                        closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          if (action === 'create' || action === 'update') {
                            history.push('/production/cooperation')
                          }
                        }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('cooperationUpdate') : t('cooperationCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                      <a onClick={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/production/cooperation')
                        }
                      }}
                          className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update') &&
                      <CooperationFormComponent backlink={'/production/cooperation'}/>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }
            {entity === 'project-item' && (!action || action === 'update' || action === 'create') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('productionProjectItem')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                    <Button
                      type="button"
                      label={t('detailedSearch')}
                      icon={detailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
                      className="p-button-outlined p-mr-2"
                      onClick={() => setDetailedSearchVisible(v => !v)}
                    />
                    {/* <a onClick={() => {
                      history.push('/production/project-item/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      {t('addProductionProjectItem')}
                    </a> */}
                  </div>
                </div>
                <Panel>
                  <ProjectitemListComponent backlink={'/production/project-item'}
                    view={window.App.urlVars().view} 
                    detailedSearchVisible={detailedSearchVisible}
                    onDetailedSearchVisibleChange={setDetailedSearchVisible}
                    onDetailedSearchActiveChange={setDetailedSearchActive}
                  />
                </Panel>
              </div>
            }
            {entity === 'project-item' && (action === 'create' || action === 'update') &&
              <Sidebar position="left"
                        showCloseIcon={false}
                        visible={action === 'create' || action === 'update'}
                        closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          if (action === 'create' || action === 'update') {
                            history.push('/production/project-item')
                          }
                        }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {t('productionProjectItem')} {id ? t('updateSuffix') : t('createSuffix')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                      <a onClick={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/production/project-item')
                        }
                      }}
                          className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update') &&
                      <ProjectitemFormComponent backlink={'/production/project-item'}/>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }
            {(entity === 'project-item') && action === 'read' && (
              <div className="PageContent p-p-5 p-mx-auto">
                <div className="p-grid">
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                    <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                      {/* {job?.project_number} - {job?.technology?.name} */}
                      {projectItemTitle}
                    </h2>
                  </div>
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                    <Button
                      type="button"
                      label={t("downloadWorksheet")}
                      icon={loadingWorksheetDownload ? "pi pi-spin pi-spinner" : "pi pi-download"}
                      className="p-button-secondary p-ml-2"
                      loading={loadingWorksheetDownload}
                      disabled={loadingWorksheetDownload}
                      onClick={downloadWorksheet}
                    />
                    <a
                      onClick={() => {
                        history.push(getProjectItemBacklink());
                      }}
                      className="p-button p-button-secondary p-ml-2"
                    >
                      <i className="pi pi-arrow-left"></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <TabView renderActiveOnly="true" className="tabview-header-icon menu" style={{ border: 'none' }}>
                    <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                      <div className="p-grid">
                        <div className="p-col-12 p-lg-6">
                          <div className="p-grid">
                            <div className="p-col-12 p-lg-12 p-col-align-center p-text-center p-text-lg-left">
                              <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                                {t('basicData')}
                              </h3>
                            </div>
                          </div>
                          <ProjectitemShowComponent id={id} action="read" onStatusColorLoaded={setProjectStatusColor}/>
                          <div
                            className="status-color-block p-mt-3"
                            style={{'--status-color': projectStatusColor}}
                          >
                            <div className="p-grid">
                              <div className="p-col-12 p-lg-12 p-col-align-center p-text-center p-text-lg-left">
                                <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                                  {t('projectItem')}
                                </h3>
                              </div>
                            </div>
                            <ProjectProjectitemListComponent view="productionProjectItem"/>
                          </div>
                        </div>
                        <div className="p-col-12 p-lg-6">
                          <div className="p-grid">
                            <div className="p-col-12 p-lg-12 p-col-align-center p-text-center p-text-lg-left">
                              <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                                {t('taskListShort')}
                              </h3>
                            </div>
                          </div>

                          <ProductionjobListComponent
                            view="cards"
                            projectItemId={id}
                            editableStatus={true}
                          />
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel header={t('tabCurrentStock')} leftIcon="pi pi-list">
                      <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                          <div className="p-grid p-mb-2">
                            <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                              <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                                {t('tabCurrentStock')}
                              </h3>
                            </div>
                            <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                              <Button
                                type="button"
                                label="Készletre gyártás"
                                icon="pi pi-plus"
                                className="p-button-success"
                                onClick={() => setStockDialogVisible(true)}
                              />
                            </div>
                          </div>
                          <InventoryListComponent
                            view="production"
                            projectItemId={id}
                          />
                        </div>
                      </div>
                    </TabPanel>
                  </TabView>
                </Panel>
              </div>
            )}
            {entity === 'production-item' && (!action || action === 'update' || action === 'create') && (localStorage.getItem('roles') || '[]').includes('role_production_item_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('taskList')}
                    </h2>
                  </div>
                  {/* <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                    <a onClick={() => {
                      history.push('/production-item/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      Új tmp
                    </a>
                  </div> */}
                </div>
                <Panel>
                  <ProductionitemListComponent backlink={'/production/productionoverview'}/>
                </Panel>
              </div>
            }
            {(entity === 'production-item' || entity === 'productionoverview') && action === 'read' && (
              <div className="PageContent p-p-5 p-mx-auto">
                <div className="p-grid">
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                    <h2 className="p-m-0 p-p-0 text-primary p-d-inline">
                      {job?.project_number} - {job?.technology?.name}
                    </h2>
                  </div>
                  <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                    <a
                      onClick={() => {
                        history.push('/production/productionoverview');
                      }}
                      className="p-button p-button-secondary p-ml-2"
                    >
                      <i className="pi pi-arrow-left"></i>
                      &nbsp;
                      {t('back')}
                    </a>
                  </div>
                </div>
                <Panel>
                  <TabView renderActiveOnly="true" className="tabview-header-icon menu" style={{ border: 'none' }}>
                    <TabPanel header={t('tabBasicData')} leftIcon="pi pi-list">
                      <div className="p-grid">
                        <div className="p-col-12">
                          <div className="p-grid">
                            <div className="p-col-12 p-lg-12 p-col-align-center p-text-center p-text-lg-left">
                              <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                                {t('fieldName')}
                              </h3>
                            </div>
                          </div>
                          <ProductionjobListComponent productionItemId={id} onLoaded={(job) => setJob(job || {})} />
                        </div>
                      </div>
                    </TabPanel>
                  </TabView>
                </Panel>
              </div>
            )}
            {entity === 'track-log' && (!action || action === 'update' || action === 'create') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('productionData')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                    <Button
                      type="button"
                      label={t('detailedSearch')}
                      icon={detailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
                      className="p-button-outlined p-mr-2"
                      onClick={() => setDetailedSearchVisible(v => !v)}
                    />
                    {/* <a onClick={() => {
                      history.push('/tmp/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      Új tmp
                    </a> */}
                  </div>
                </div>
                <Panel>
                  <TracklogListComponent backlink={'/production/track-log'}  
                    view={window.App.urlVars().view} 
                    detailedSearchVisible={detailedSearchVisible}
                    onDetailedSearchVisibleChange={setDetailedSearchVisible}
                    onDetailedSearchActiveChange={setDetailedSearchActive}/>
                </Panel>
              </div>
            }
            {entity === 'machine-log' && (!action || action === 'update' || action === 'create') && (localStorage.getItem('roles') || '[]').includes('role_machine_log_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('machineLogs')}
                    </h2>
                  </div>
                  {/* <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                    <a onClick={() => {
                      history.push('/tmp/create')
                    }}
                        className={"p-button  p-button-success p-ml-2"}>
                      <i className={"pi pi-plus"}></i>
                      &nbsp;
                      Új tmp
                    </a>
                  </div> */}
                </div>
                <Panel>
                  <MachinelogListComponent backlink={'/production/machine-log'}/>
                </Panel>
              </div>
            }
            {entity === 'worksheet' && action === 'update' &&
              <Sidebar position="left"
                       showCloseIcon={false}
                       visible={action === 'create' || action === 'update'}
                       closeOnEscape={true}
                       style={{width: '780px'}}
                       onHide={() => {
                         history.push('/production/schedule-item')
                       }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('worksheetUpdate') : t('worksheetCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                  <span className={"p-mr-2"}>

                  </span>
                      <a onClick={() => {
                        history.push('/production/schedule-item')
                      }}
                         className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  {/*<Panel>// TMP 2.0*/}
                  <WorksheetFormComponent backlink={'/production/schedule-item'}/>
                  {/*</Panel>*/}
                </div>
              </Sidebar>
            }
            {entity === 'production-status' && (localStorage.getItem('roles') || '[]').includes('role_production_status_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('productionStatus')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <div style={{display: 'inline-block', minWidth: '320px', textAlign: 'left'}}>
                      <Dropdown
                        value={window.App.urlVars().floorPlanId ? Number(window.App.urlVars().floorPlanId) : selectedFloorPlanId}
                        options={floorPlans}
                        optionLabel="name"
                        optionValue="id"
                        placeholder={t('selectFloorPlan')}
                        showClear
                        onChange={(e) => {
                          const value = e.value || null;
                          setSelectedFloorPlanId(value);
                          if (value) {
                            history.replace('/production/production-status?floorPlanId=' + value);
                          } else {
                            history.replace('/production/production-status');
                          }
                        }}
                        style={{width: '100%'}}
                      />
                    </div>
                  </div>

                  <div className={"p-col-12"}>
                    <Panel>
                      <ProductionstatusFloorplanComponent
                        floorPlanId={window.App.urlVars().floorPlanId ? Number(window.App.urlVars().floorPlanId) : selectedFloorPlanId}
                      />
                    </Panel>
                  </div>
                </div>
              </div>
            }
            {entity === 'floor-plan' && (localStorage.getItem('roles') || '[]').includes('role_floor_plan_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('productionStatus')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <div style={{display: 'inline-block', minWidth: '320px', textAlign: 'left'}}>
                      <Dropdown
                        value={window.App.urlVars().floorPlanId ? Number(window.App.urlVars().floorPlanId) : selectedFloorPlanId}
                        options={floorPlans}
                        optionLabel="name"
                        optionValue="id"
                        placeholder={t('selectFloorPlan')}
                        showClear
                        onChange={(e) => {
                          const value = e.value || null;
                          setSelectedFloorPlanId(value);
                          if (value) {
                            history.replace('/production/floor-plan?floorPlanId=' + value);
                          } else {
                            history.replace('/production/floor-plan');
                          }
                        }}
                        style={{width: '100%'}}
                      />
                    </div>
                  </div>

                  <div className={"p-col-12"}>
                    <Panel>
                      <FloorplanComponent
                        floorPlanId={window.App.urlVars().floorPlanId ? Number(window.App.urlVars().floorPlanId) : selectedFloorPlanId}
                      />
                    </Panel>
                  </div>
                </div>
              </div>
            }
            {entity === 'machine' && (!action || action === 'update' || action === 'create') && (localStorage.getItem('roles') || '[]').includes('role_machine_read') &&
              <div className={"PageContent p-p-5 p-mx-auto"}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                    <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                      {t('machineList')}
                    </h2>
                  </div>
                  <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                    {localStorage.getItem('roles').toString().includes('role_machine_write') && (
                      <a onClick={() => {
                        history.push('/production/machine/create')
                      }}
                          className={"p-button  p-button-success p-ml-2"}>
                        <i className={"pi pi-plus"}></i>
                        &nbsp;
                        {t('addMachine')}
                      </a>
                    )}
                  </div>
                </div>
                <Panel>
                  <MachineListComponent backlink={'/production/machine'}/>
                </Panel>
              </div>
            }
            {entity === 'machine' && (action === 'create' || action === 'update') &&
              <Sidebar position="left"
                        showCloseIcon={false}
                        visible={action === 'create' || action === 'update'}
                        closeOnEscape={true}
                        style={{width: '780px'}}
                        onHide={() => {
                          if (action === 'create' || action === 'update') {
                            history.push('/production/machine')
                          }
                        }}>
                <div className={"PageContent p-px-1 p-py-3 p-mx-auto"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                      <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                        {id ? t('machineUpdate') : t('machineCreate')}
                      </h2>
                    </div>
                    <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>
                    <span className={"p-mr-2"}>
  
                    </span>
                      <a onClick={() => {
                        if (action === 'create' || action === 'update') {
                          history.push('/production/machine')
                        }
                      }}
                          className={"p-button  p-button-secondary p-ml-2"}>
                        <i className={"pi pi-arrow-left"}></i>
                        &nbsp;
                        {t('back')}
                      </a>
                    </div>
                  </div>
                  <Panel>
                    {(action === 'create' || action === 'update') &&
                      <MachineFormComponent backlink={'/production/machine'}/>
                    }
                  </Panel>
                </div>
              </Sidebar>
            }
            <Sidebar
              position="bottom"
              visible={window.App.urlVars().search === 'employee'}
              closeOnEscape={true}
              style={{width: '100%', height: '80%'}}
              onHide={() => {
                const basePath =
                  '/production/' +
                  entity + '/' +
                  action +
                  (id && id !== 'undefined' ? '/' + id : '');

                const vars = window.App.urlVars();
                const newVars = {...vars};
                delete newVars.search;

                let query = '?';
                Object.entries(newVars).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== '') {
                    query += key + '=' + value + '&';
                  }
                });

                history.push(basePath + (query === '?' ? '' : query));
              }}
            >
              <div className="p-grid p-mt-3">
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left">
                  <h3 className="p-m-0 p-p-0 text-primary p-d-inline">
                    {t('employeeSearch')}
                  </h3>
                </div>
                <div className="p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right">
                </div>
              </div>

              <Panel>
                <EmployeeListComponent
                  view="search"
                  backlink={
                    '/production/' +
                    entity + '/' +
                    action +
                    (id && id !== 'undefined' ? '/' + id : '')
                  }
                />
              </Panel>
            </Sidebar>
            <Dialog visible={window.App.urlVars().create === 'schedule' || window.App.urlVars().update === 'schedule'}
                    style={{width: '90%'}}
                    header={t('addSchedule')}
                    modal
                    onHide={() => {
                      history.go(-1)
                    }}>
              <ScheduleFormComponent backlink={'/production/schedule-group'}/>
            </Dialog>
            <Sidebar position="bottom"
                     visible={window.App.urlVars().search === 'partner'}
                     closeOnEscape={true}
                     style={{width: '100%', height: '80%'}}
                     onHide={() => {
                       history.push('/production/' + entity + '/' + action + '/' + id)
                     }}>
              <div className={"p-grid p-mt-3"}>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-left"}>
                  <h3 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                    {t('partnerSearch')}
                  </h3>
                </div>
                <div className={"p-col-12 p-lg-6 p-col-align-center p-text-center p-text-lg-right"}>

                </div>
              </div>
              <Panel>
                <PartnerListComponent view={"search"} backlink={'/production/' + entity + '/' + action + '/' + id} forcedSearchQuery={
                  window.App.urlVars().partnerFilter === 'vendor_service'
                    ? 'search[vendor_service][operator]==&search[vendor_service][value]=true'
                    : ''
                }/>
              </Panel>
            </Sidebar>
            <Dialog visible={window.App.urlVars().create === 'partner'}
                    style={{width: '980px'}}
                    header={t('partnerCreate')}
                    modal
                    onHide={() => {
                      history.push('/production/' + entity + '/' + action + '/' + id)
                    }}>
              <PartnerFormComponent backlink={'/production/' + entity + '/' + action + '/' + id}/>
            </Dialog>
            <Dialog
              visible={stockDialogVisible}
              style={{width: '420px'}}
              header="Készletre gyártás"
              modal
              onHide={() => {
                if (!stockLoading) {
                  setStockDialogVisible(false);
                  setStockQuantity(null);
                }
              }}
              footer={
                <>
                  <Button
                    type="button"
                    label={t('cancel')}
                    icon="pi pi-times"
                    className="p-button-secondary"
                    disabled={stockLoading}
                    onClick={() => {
                      setStockDialogVisible(false);
                      setStockQuantity(null);
                    }}
                  />

                  <Button
                    type="button"
                    label={t('save')}
                    icon={stockLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'}
                    className="p-button-success"
                    loading={stockLoading}
                    disabled={stockLoading}
                    onClick={createStock}
                  />
                </>
              }
            >
              <div className="p-fluid">
                <div className="p-field">
                  <label>Mennyiség</label>
                  <InputNumber
                    value={stockQuantity}
                    onValueChange={(e) => setStockQuantity(e.value)}
                    locale="hu-HU"
                    min={0}
                    minFractionDigits={0}
                    maxFractionDigits={9}
                  />
                </div>
              </div>
            </Dialog>
          </>
        )
        :
        (
          <p className={"p-text-center p-my-5 p-py-5"}>
            <i className={"pi pi-exclamation-circle p-d-block p-mb-5"} style={{'fontSize': '5em'}}></i>
            <span className={"p-text-bold p-d-block "}>Ehhez a modulhoz sajnos nem rendelkezel hozzáféréssel.</span>
            Amennyiben további információra van szükséged írj emailt a {process.env.REACT_APP_DEVOPS_CONTACT} címre.
          </p>
        )
      }
    </div>
  )
}
export default withTranslation('common')(ProjectPage);
